/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Accounting or records mode used for the yearly filing.
 * @nullable
 */
export type UpdateSloveniaTaxProfileBodyYearlyReportingAccountingType = typeof UpdateSloveniaTaxProfileBodyYearlyReportingAccountingType[keyof typeof UpdateSloveniaTaxProfileBodyYearlyReportingAccountingType] | null;


export const UpdateSloveniaTaxProfileBodyYearlyReportingAccountingType = {
  records: 'records',
  single_entry: 'single_entry',
  double_entry: 'double_entry',
} as const;
